import React, { useState, useRef, useEffect } from 'react';
import { StyleSheet, Text, View, Image, Dimensions, ActivityIndicator } from 'react-native';
// Import the main component
import { Viewer , Worker } from '@react-pdf-viewer/core';

// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';

import { Modal, Button, Spin } from 'antd';
import $ from "jquery";
//import { Modal, Button } from "react-bootstrap";

import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import './css/watermark.css'
import getUserId from "../../shared/core/GetToken"
import Iframe from './Iframe';

import Settings from "../../shared/config/Settings";
import { useDispatch, useSelector } from 'react-redux';
import { appServices } from '../../shared/redux/actions/appServices';
import getUserInfo from '../../shared/core/GetTokenized';

const renderToolbar = (Toolbar) => (
    <>
        <Toolbar />
        <div
            style={{
                borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                marginTop: '4px',
                padding: '4px',
            }}
        >
            Custom element
        </div>
    </>
);
const ServiceHandler = props => {
    const {GetScreeningTemplateHTML , isGetScreeningTemplateHTML} =useSelector((state)=> state.GetScreeningTemplateHTML)
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const PatienInformation = JSON.parse(information);
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const dispatch= useDispatch()
    // const htmlObj= {
    //     // PatientID : "" ,
    //     ScreeningID  : screeningId,
    // }
    // const displayLetter = ScreaningID => {
    //     // alert(ScreaningID)
    //     setIsLoadingPdf(true);
    //     var requestOptions = {
    //         method: 'GET',
    //         redirect: 'follow'
    //     };

    //     getUserId().then((userInfo) => {
    //         const item = JSON.parse(userInfo);
    //         setusername(item.username)
    //         fetch(Settings.apiUrl + "Patient/GetScreeningTemplateHTML?Token=" + item.token+ "&ScreeningID=" + ScreaningID, requestOptions)
    //             .then(data => data.json())
    //             .then(json => {
    //                 console.log(JSON.stringify(json , "jason"))
                   
    //                     var decodedHTML = atob(json[0].entry[0].resource.extension[0].valueString)
    //                     setVisible(true)
    //                     setHtmlLetter(decodedHTML)
    //                     setHtmlLetter((state) => {
    //                         return state;
    //                     });
    //                     //document.getElementById("showPDFLetters").innerHTML = decodedHTML

    //                     setIsLoadingPdf(false);
                    

    //             })
    //             .catch(error => console.log('error', error)).finally(() => {
    //                 setIsLoadingPdf(false)

    //             });
    //     });
    // }

    
    useEffect(() => {

        const onDimensionsChange = ({ window }) => {
            let wrapperWidth = $('.grid-items-wrapper').width();
            let maxCards = Number((wrapperWidth / 210).toFixed(0));
            let cardWidth = (100 / maxCards).toFixed(2);
            $('.drive-item').css('width', 'calc(' + cardWidth + '% - 30px)');
        }

        Dimensions.addEventListener('change', onDimensionsChange)

        return () => Dimensions.removeEventListener('change', onDimensionsChange)

    }, [])

    

    //print configrations
   
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    return (
        <div className="drive-item module text-center">
            <div className="drive-item-inner module-inner">
                <div className="drive-item-title">
                    <a>{props.letterDetail}</a>
                    <p><small>Added: {props.letterDate}</small></p>
                </div>
                <div className="drive-item-thumb">
                    <a ><i className="fa fa-file-pdf-o text-danger" /></a>
                    {(isGetScreeningTemplateHTML && props.screeningId === props.ScreaningID) && <View style={{ paddingTop: 20 }}><ActivityIndicator size="small" color="#00A1DE" /></View>}
                </div>
            </div>
            <div className="drive-item-footer module-footer">
                <ul className="utilities list-inline">
                    <li><a onClick={() => {
                        props.setscreeningId(props.ScreaningID)
                        dispatch(appServices.GetScreeningTemplateHTML({
                            PatientID: Profile[0].resource.id,
                            ScreeningID : props.ScreaningID  
                        }))
                    // displayLetter(props.ScreaningID)
                    } }data-toggle="tooltip" data-placement="top" title data-original-title="Download">View </a></li>
                </ul>
            </div>


            {/* {
                visible && <Iframe content={htmlLetter} />
            } */}
         


        </div>
    );
}
export default ServiceHandler
